import { OktaAuth } from '@okta/okta-auth-js';

export const OKTA_LOGIN_PATH = '/okta/login';
export const OKTA_CALLBACK_PATH = '/okta/callback';

export const OKTA_SOURCE_PARAM = 'source';
export const OKTA_LOGOUT_PARAM = 'logout';

export const mainPotsPortalUrl: Readonly<URL> | null = (() => {
  const raw = process.env.REACT_APP_MAIN_POTS_PORTAL_URL;
  if (!raw) return null;
  try {
    return Object.freeze(new URL(new URL(raw).origin));
  } catch {
    return null;
  }
})();

export const parseOktaLoginSource = (value: string | null): string | null => {
  try {
    if (!value) return null;
    const url = new URL(value);
    if (!url.hostname) return null;
    const isLocalhost = url.hostname === 'localhost' || url.hostname === '127.0.0.1';
    if (url.protocol !== 'https:' && !(url.protocol === 'http:' && isLocalhost)) return null;
    if (url.origin === window.location.origin) return null;
    return url.origin;
  } catch {
    return null;
  }
};

const OKTA_LOGIN_SOURCE_KEY = 'tc-okta-login-source';

export const setOktaLoginSource = (value: string | null): void =>
  value ? localStorage.setItem(OKTA_LOGIN_SOURCE_KEY, value) : localStorage.removeItem(OKTA_LOGIN_SOURCE_KEY);

export const getOktaLoginSourceLoginUrl = (): string | null => {
  try {
    const source = parseOktaLoginSource(localStorage.getItem(OKTA_LOGIN_SOURCE_KEY));
    if (!source) return null;
    return new URL('/authentication/login', source).toString();
  } catch {
    return null;
  }
};

export const oktaAuth = new OktaAuth({
  issuer: process.env.REACT_APP_OKTA_PUBLIC_ISSUER || '', // https://telcloud.okta.com/oauth2/default
  clientId: process.env.REACT_APP_OKTA_PUBLIC_CLIENT_ID || '',
  redirectUri: new URL(OKTA_CALLBACK_PATH, window.location.origin).toString(),
  postLogoutRedirectUri: new URL(`/authentication/login?${OKTA_LOGOUT_PARAM}=true`, window.location.origin).toString(),
  scopes: ['openid', 'email', 'offline_access', 'profile'],
});

export const terminateOktaSession = async (): Promise<void> => {
  // NOTE: Use a best-effort approach to terminate the Okta session. Any of the following steps may fail.
  for (const terminator of [
    () => oktaAuth.revokeAccessToken(),
    () => oktaAuth.revokeRefreshToken(),
    () => oktaAuth.closeSession(),
    () => oktaAuth.clearStorage(),
  ] as (() => void | Promise<void>)[]) {
    try {
      await terminator();
    } catch {
      // ignore
    }
  }
};
